import { useEffect } from "react";
import { useSocket } from "../provider/SocketProvider";
import { dispatch } from "../../store";
import { dashboardActions } from "../../store/dashboard/dashboard-slice";

const useDashboardSocket = (marketId = "") => {
  const { socket, isConnected } = useSocket();

  useEffect(() => {
    if (!isConnected || !marketId || !socket) return;

    socket.emit("subscribe_markets", marketId);

    const handleSubscribedMarkets = (data) => {
      for (const key in data?.snapshot) {
        if (!Object.hasOwn(data?.snapshot, key)) continue;

        const element = data?.snapshot[key];
        if (!element) return;

        dispatch(
          dashboardActions.updateMatchFeed({ marketId: key, updated: element }),
        );
      }
    };

    const handleMarketUpdate = (data) => {
      if (!data?.marketId || !data?.payload?.payload?.runners) return;
      dispatch(
        dashboardActions.updateMatchFeed({
          marketId: data?.marketId,
          updated: data?.payload,
        }),
      );
    };

    socket.on("subscribed_markets", handleSubscribedMarkets);
    socket.on("market_update", handleMarketUpdate);

    return () => {
      socket.off("subscribed_markets", handleSubscribedMarkets);
      socket.off("market_update", handleMarketUpdate);
      socket.emit("unsubscribe_markets", marketId);
    };
  }, [marketId, isConnected, socket]);
};

export default useDashboardSocket;
